<div class="app-search-dialog">
    <h3 class="mat-dialog-title mb-3 font-weight-normal" mat-dialog-title id="mat-dialog-title-1">
        <svg class="icon icon--24 mr-3"><use href="#icon-search" /></svg>{{ 'web.search' | translate }}
    </h3>
    <mat-dialog-content class="mat-typography">
        <div class="row no-gutters mb-3 mb-md-0">
            <div class="col-md-7">
                <mat-form-field class="app-full-width">
                    <input
                        matInput
                        placeholder="{{ 'web.enter_search_text' | translate }}"
                        type="search"
                        data-cy="search-text"
                        class="form-control app-search-fulltext"
                        [formControl]="searchForm.searchFormControl"
                    />
                    <mat-hint class="d-none d-md-block">{{ 'web.enter_text_min_length_3' | translate }}</mat-hint>
                    @if ( !searchForm.searchFormControl?.pristine && searchForm.searchFormControl?.hasError('minlength')
                    ) {
                    <mat-error class="d-none d-md-block">
                        {{ 'web.error_min_legth' | translate }}:
                        {{ searchForm.searchFormControl.errors.minlength.requiredLength }} ({{
                            searchForm.searchFormControl.errors.minlength.actualLength
                        }})
                    </mat-error>
                    } @if (searchForm.searchFormControl?.hasError('required')) {
                    <mat-error class="d-none d-md-block">
                        {{ 'web.error_required' | translate }}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-md-5">
                @if (!isMobile) {
                <select class="custom-select border-light2 mb-3" [formControl]="searchForm.sportFormControl">
                    <option value="0">{{ 'web.all_sports' | translate }}</option>
                    @for (sport of sport.data; track $index) {
                    <option [value]="sport.id">
                        {{ 'sport.' + sport.code_name | translate }}
                    </option>
                    }
                </select>
                } @else {
                <select class="custom-select border-light2 mb-3" [formControl]="searchForm.sportFormControl">
                    <option value="0">{{ 'web.all_sports' | translate }}</option>
                    @for (sport of sport.data; track $index) {
                    <option [value]="sport.id">
                        {{ 'sport.' + sport.code_name | translate }}
                    </option>
                    }
                </select>
                }
            </div>
        </div>

        <div class="mt-5">
            @if (loaded) {
            <div>
                @if (loadedError) {
                <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                    <div class="text-center pt-7">
                        <svg class="icon icon--64 mb-4"><use href="#icon-empty" /></svg>
                        <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                        <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
                    </div>
                </div>
                } @for (row of data | keys; track $index) { @if (notEmpty(row.value)) {
                <div data-cy="search-result">
                    <h4 class="table-sport__head mb-0 bg-dark" [attr.data-cy]="'search-head-' + row.key">
                        {{ 'web.' + row.key | translate }}
                    </h4>
                    @for (sport of row.value | keys; track $index) {
                    <div class="table-sport__content">
                        <h5 class="table-sport__subhead mb-0 bg-white d-flex align-items-center app-search-sport">
                            <!-- <img src="/img/sports/{{ sport.key }}.png" alt="{{ 'web.' + sport.key | translate }}" width="20" class="mr-2"> -->
                            {{ 'sport.' + transformate(sport.key) | translate }}
                        </h5>
                        @for (item of sport.value; track trackById($index, item)) {
                        <div class="table-sport__row border-white">
                            <div class="table-sport__cell table-sport__cell--img ml-2">
                                @if (item.image) {
                                <img [src]="item.image" class="img-fluid" [alt]="item.name" />
                                }
                            </div>
                            <div class="table-sport__cell table-sport__cell--team">
                                <a
                                    (click)="goToDetail(row.key, item)"
                                    class="app-cursor font-weight-bold app-search-dialog__item"
                                >
                                    {{ item.name }}
                                    @if (item.category) { -
                                    <small
                                        >{{ item.category }} @if (item.rawName &&
                                        isSupportedSport(item.sport_code_name)) { ({{ item.rawName }}) }
                                    </small>
                                    } @if (item.tournaments) { -
                                    <small>
                                        {{ item.tournaments[0]?.sub_tournament_name }}
                                        @if ( item.tournaments[0]?.category_name &&
                                        item.tournaments[0]?.category_name.length > 1 ) { ({{
                                            item.tournaments[0]?.category_name
                                        }}) }
                                    </small>
                                    }
                                </a>
                                @if (row.key == 'participants') {
                                <div>
                                    <app-favorite [participantId]="item.id" [type]="'participant'">
                                        <span notactive>{{ 'web.add_participant_to_favorites' | translate }}</span>
                                        <span active>{{ 'web.remove_participant_from_favorites' | translate }}</span>
                                    </app-favorite>
                                </div>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                } } @if (noData()) {
                <div class="row justify-content-center" data-cy="search-not-found">
                    <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                        <div class="text-center pt-2">
                            <svg class="icon icon--64 mb-4"><use href="#icon-empty" /></svg>
                            <h4 class="font-weight-bold">{{ 'web.we_are_sorry_search' | translate }}</h4>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else { @if (!pristine) {
            <div class="col align-self-center"><app-page-loader></app-page-loader></div>
            } } @if (pristine || noData()) {
            <div data-cy="search-nodata">
                <h4 class="table-sport__subhead mb-0 bg-white d-flex align-items-center">
                    <strong>{{ 'web.latest_search' | translate }}</strong>
                </h4>
                @if (getLatest('participants').length > 0) {
                <div>
                    <h4 class="table-sport__head mb-0 bg-dark">{{ 'web.participants' | translate }}</h4>
                    @for (item of getLatest('participants'); track trackById($index, item)) {
                    <div class="row" class="table-sport__row border-white">
                        <div class="table-sport__cell table-sport__cell--img ml-2">
                            <img [src]="item.image" class="img-fluid" [alt]="item.name" />
                        </div>
                        <div class="table-sport__cell table-sport__cell--team">
                            <a
                                (click)="goToDetail('participants', item)"
                                class="app-cursor app-search-dialog__item"
                                data-cy="search-last-participant"
                            >
                                {{ item.name }}
                                @if (item.tournaments && item.tournaments.length > 0) { -
                                {{ item.tournaments[0].sub_tournament_name }} ({{ item.tournaments[0].category_name }})
                                }
                            </a>
                            <div>
                                <app-favorite [participantId]="item.id" [type]="'participant'">
                                    <span notactive>{{ 'web.add_participant_to_favorites' | translate }}</span>
                                    <span active>{{ 'web.remove_participant_from_favorites' | translate }}</span>
                                </app-favorite>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                } @if (getLatest('players').length > 0) {
                <div>
                    <h4 class="table-sport__head mb-0 bg-dark">{{ 'web.players' | translate }}</h4>
                    @for (item of getLatest('players'); track trackById($index, item)) {
                    <div class="row" class="table-sport__row border-white">
                        <div class="table-sport__cell table-sport__cell--img ml-2">
                            <img [src]="item.image" class="img-fluid" [alt]="item.name" />
                        </div>
                        <div class="table-sport__cell table-sport__cell--team">
                            <a (click)="goToDetail('players', item)" class="app-cursor app-search-dialog__item">
                                {{ item.name }}
                            </a>
                            <div>
                                <app-favorite [participantId]="item.id" [type]="'participant'">
                                    <span notactive>{{ 'web.add_participant_to_favorites' | translate }}</span>
                                    <span active>{{ 'web.remove_participant_from_favorites' | translate }}</span>
                                </app-favorite>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                } @if (getLatest('tournaments').length > 0) {
                <div>
                    <h4 class="table-sport__head mb-0 bg-dark">{{ 'web.tournaments' | translate }}</h4>
                    @for (item of getLatest('tournaments'); track trackById($index, item)) {
                    <div class="row" class="table-sport__row border-white">
                        <div class="table-sport__cell table-sport__cell--img ml-2">
                            @if (item.image) {
                            <img [src]="item.image" class="img-fluid" [alt]="item.name" />
                            }
                        </div>
                        <div class="table-sport__cell table-sport__cell--team">
                            <a (click)="goToDetail('tournaments', item)" class="app-cursor app-search-dialog__item">
                                {{ item.name }}
                                @if (item.tournaments && item.tournaments.length > 0) { -
                                {{ item.tournaments[0].sub_tournament_name }} ({{ item.tournaments[0].category_name }})
                                }
                            </a>
                            <div>
                                <app-favorite [participantId]="item.id" [type]="'participant'">
                                    <span notactive>{{ 'web.add_participant_to_favorites' | translate }}</span>
                                    <span active>{{ 'web.remove_participant_from_favorites' | translate }}</span>
                                </app-favorite>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
            }
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-dialog-close class="btn btn-outline-secondary btn-sm">{{ 'web.close' | translate }}</button>
    </mat-dialog-actions>
</div>
